import React, { useEffect, useState } from "react";
import "./FormSection.scss";

const FormSection = ({ formData, setPostScoringDetails, isDisable, setAuditConclusionTrue, auditConclusionTrue,setVersion2ScoringData  }) => {
  const [responses, setResponses] = useState({});

  // Initialize responses when formData is available
  useEffect(() => {
    if (formData?.length) {
      setResponses((prevResponses) => {
        const updatedResponses = { ...prevResponses };

        formData.forEach((section) => {
          if (updatedResponses[section.id] === undefined) {
            updatedResponses[section.id] = section.defaultText ?? "";
          }
        });

        return updatedResponses;
      });
    }
  }, [formData]);

  const checkAllValues = formData.every(item => responses[item.id]);

  useEffect(() => {
    if(checkAllValues ){
      setAuditConclusionTrue(checkAllValues)
    }else{
      setAuditConclusionTrue(false)
    }

  
  },[auditConclusionTrue,checkAllValues])

  // Handle input change
  const handleChange = (id, value) => {
    setResponses((prev) => {
      const updatedResponses = { ...prev, [id]: value };

      // Update parent component state with new responses
      setPostScoringDetails((prevDetails) => ({
        ...prevDetails,
        areaStrength: updatedResponses?.strength || "",
        areaOpportunity: updatedResponses?.opportunity || "",
        zeroFindingJustification: updatedResponses?.zero_findings || "",
      }));
      setVersion2ScoringData((prev) => ({
        ...prev,
        audit_conclusion : {
          ...prev.audit_conclusion,
          area_opportunity:updatedResponses?.opportunity || "",
          area_strength: updatedResponses?.strength || "",
          zero_finding_justification: updatedResponses?.zero_findings || "",

        }
      }))

      return updatedResponses;
    });
  };

  return (
    <div className="bottom-form-section">
      {formData.map((section) => (
        <div key={section.id} style={{ marginBottom: "20px" }}>
          <label htmlFor={section.id} className="bottom-form-label">
            {section.label} <span style={{color: "red", fontSize: "20px"}} >*</span>
          </label>
          <textarea
            id={section.id}
            rows="2"
            className="bottom-from-input"
            value={responses[section.id] ?? ""}
            onChange={(e) => handleChange(section.id, e.target.value)}
            disabled={isDisable}
          />
        </div>
      ))}
    </div>
  );
};

export default FormSection;
